import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState, useEffect } from 'react';
import * as _ from 'lodash';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { setSelectedLocation } from '../../../redux/spaces-slice';
import { Flex } from '@magnetic/flex';
import { Skeleton } from '@magnetic/skeleton';
import StyledFloorCircle from './FloorCircle/Styled-FloorCircle';
import DetailedFloorRow from './DetailedFloorRow';
import { SelectFloorSubTitle, FloorContainer } from './styled-floor-selector';
import useFloors from './hook/floor-selection';
import { getContext } from '../../../redux/spaces-slice';
import { setCurrentSlide } from '../../../../../store/uislice';
import { store } from '../../../../../store/store';
// Props for FloorSelector to notify parent of selection
export default function FloorSelector() {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { floors, allFloorsHidden } = useFloors();
    const context = useSelector(getContext);
    const buildingConfig = context.appConfig.building;
    const floorOccupancy = buildingConfig.showFloorOccupancy;
    const [slide, setSlide] = useState(1);
    const showNonInteractiveCarousel = !(context === null || context === void 0 ? void 0 : context.interactive) && floors.length > 12;
    const setSelectedLocationId = ({ id = -1 }) => {
        if (id !== -1) {
            const strId = id.toString();
            console.log('@@@ FloorSelector selectedFloor', strId);
            dispatch(setSelectedLocation(strId));
        }
    };
    const contextInfo = useSelector(getContext);
    const shouldShowWhereAmI = 'isWhereAmIEnabled' in contextInfo && contextInfo.isWhereAmIEnabled !== null
        ? contextInfo.isWhereAmIEnabled
        : (contextInfo === null || contextInfo === void 0 ? void 0 : contextInfo.deviceLocationId) !== null;
    const floorRows = floors.length < 10
        ? floors.map((floor) => (_jsx(DetailedFloorRow, { percentage: floor.percentage, floorStatus: floor.floorStatus, floorLevel: floor.floorLevel, isSelected: floor.isSelected && shouldShowWhereAmI, selectLocation: setSelectedLocationId, floor: floor, showFloorOccupancy: floorOccupancy }, `floor-${floor.id}-${floor.floorLevel}`)))
        : _.chunk(floors, 3).map((floorChunk) => (_jsx(Flex, Object.assign({ className: "floor-row", gap: 14, style: { marginBottom: '14px' } }, { children: floorChunk.map((floor) => (_jsx(StyledFloorCircle, { className: "building_select_floor", percentage: floor.percentage, floorStatus: floor.floorStatus, floorLevel: floor.floorLevel, isSelected: floor.isSelected, showFloorOccupancy: floorOccupancy, selectLocation: setSelectedLocationId, floor: floor, 
                // Inside the circle: the floor number (floorLevel is floorNumber).
                floorShortName: floor.floorLevel }, `floor-${floor.id}-${floor.floorLevel}`))) }), floorChunk[0].id)));
    useEffect(() => {
        console.log();
        store.dispatch(setCurrentSlide({ payload: slide }));
    }, [slide]);
    useEffect(() => {
        // Auto-scroll is a non-interactive-only affordance and only makes sense when
        // the floors overflow into the carousel (>12). When interactive, or when the
        // floors fit without a horizontal carousel, never start the interval so there
        // is no auto/horizontal scrolling. (2.0 guarded this inside scrollStep with
        // `if (context?.interactive) return;`; we gate the whole effect so <12 floors
        // never scroll either.)
        if (!showNonInteractiveCarousel) {
            return;
        }
        const floorSelector = document.getElementById('building-floor-selector');
        if (!floorSelector) {
            return;
        }
        const stepSize = floorSelector.clientWidth + 10;
        const stepDelay = 5000;
        const scrollSpeed = 400;
        function scrollStep() {
            if (!floorSelector)
                return;
            const maxScroll = floorSelector.scrollWidth - floorSelector.clientWidth;
            // If we've reached (or passed) the bottom, jump back to top and pause
            if (floorSelector.scrollLeft >= maxScroll) {
                floorSelector.scrollTo({ left: 0, behavior: 'smooth' });
                setSlide(1);
            }
            else {
                // Next target position (don’t overshoot bottom)
                const nextLeft = Math.min(floorSelector.scrollLeft + stepSize, maxScroll);
                console.log('scrolling to left 2nd ', slide);
                setSlide((slide) => slide + 1);
                // Smooth scroll a chunk
                floorSelector.scrollTo({
                    left: nextLeft,
                    behavior: 'smooth',
                });
            }
            // Wait a bit so the smooth scroll can finish + viewing pause
        }
        // Start the auto-scrolling
        const interval = setInterval(scrollStep, stepDelay + scrollSpeed);
        return () => clearInterval(interval);
    }, [showNonInteractiveCarousel]);
    const NonInteractiveLayout = () => {
        return (_jsx(_Fragment, { children: _jsxs(Flex, Object.assign({ direction: "vertical", style: {
                    paddingTop: '24px',
                    overflowX: 'auto',
                    overFlowY: 'none',
                    minHeight: '92vh',
                } }, { children: [_jsx("div", Object.assign({ style: { marginLeft: '0.4vw' }, className: "action-prompt" }, { children: t('floor.select-floor') })), _jsx(SelectFloorSubTitle, Object.assign({ style: { marginLeft: '0.4vw' } }, { children: t('floor.select-floor-subtitle') })), _jsx(Flex, Object.assign({ style: { width: 'fit-content' } }, { children: Array.from({ length: Math.ceil(floorRows.length / 4) }).map((_, i) => {
                            return (_jsx(Flex, Object.assign({ direction: "vertical", style: { padding: '0vw 27px 27px 27px' } }, { children: Array.from({ length: 4 }).map((_, j) => {
                                    return floorRows[i * 4 + j];
                                }) }), i));
                        }) }))] })) }));
    };
    return showNonInteractiveCarousel ? (_jsx(NonInteractiveLayout, {})) : (_jsxs(FloorContainer, { children: [_jsx("div", Object.assign({ className: "action-prompt" }, { children: t('floor.select-floor') })), _jsx(SelectFloorSubTitle, { children: t('floor.select-floor-subtitle') }), floors.length > 0 ? (floorRows) : allFloorsHidden ? null : (_jsxs(Flex, Object.assign({ direction: "vertical", gap: 24, style: { width: '350px', marginTop: '24px' } }, { children: [_jsxs(Flex, Object.assign({ gap: 24 }, { children: [_jsx(Skeleton, { height: 60, style: {
                                    width: 60,
                                } }), _jsxs(Flex, Object.assign({ direction: "vertical", gap: 12, grow: true }, { children: [_jsx(Skeleton, { height: "sm", style: {
                                            width: '100%',
                                        } }), _jsx(Skeleton, { height: "sm", style: {
                                            width: '75%',
                                        } })] }))] })), _jsxs(Flex, Object.assign({ gap: 24 }, { children: [_jsx(Skeleton, { height: 60, style: {
                                    width: 60,
                                } }), _jsxs(Flex, Object.assign({ direction: "vertical", gap: 12, grow: true }, { children: [_jsx(Skeleton, { height: "sm", style: {
                                            width: '100%',
                                        } }), _jsx(Skeleton, { height: "sm", style: {
                                            width: '75%',
                                        } })] }))] })), _jsxs(Flex, Object.assign({ gap: 24 }, { children: [_jsx(Skeleton, { height: 60, style: {
                                    width: 60,
                                } }), _jsxs(Flex, Object.assign({ direction: "vertical", gap: 12, grow: true }, { children: [_jsx(Skeleton, { height: "sm", style: {
                                            width: '100%',
                                        } }), _jsx(Skeleton, { height: "sm", style: {
                                            width: '75%',
                                        } })] }))] }))] })))] }));
}
